import React, { useState, useRef } from "react";
import buttonDefault from "../../assets/button-default.png";
import buttonHover from "../../assets/button-hover.png";
import navigatePrev from "../../assets/navigate_next.png";
import navigateNext from "../../assets/navigate_prev.png";
import { INFRA_PAGE } from "../../data/constants";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import type { Swiper as SwiperType } from 'swiper';

const tests = INFRA_PAGE.testStandards.tests;

const TestStandardsSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(0);
  const [direction, setDirection] = useState<'left' | 'right'>('right');
  const [isAnimating, setIsAnimating] = useState(false);
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const current = tests[activeIndex];
  const prev = tests[prevIndex];
  const prevSwiperRef = useRef<HTMLButtonElement>(null);
  const nextSwiperRef = useRef<HTMLButtonElement>(null);
  const [activeMobileIndex, setActiveMobileIndex] = useState(0);
console.log('Active Mobile Index:', activeMobileIndex);



  const handleNext = () => {
    if (isAnimating) return;
    setDirection('right');
    setPrevIndex(activeIndex);
    setIsAnimating(true);
    setActiveIndex((prev) => (prev === tests.length - 1 ? 0 : prev + 1));
  };

  // Reset animation state after transition
  React.useEffect(() => {
    if (isAnimating) {
      timeoutRef.current = setTimeout(() => {
        setIsAnimating(false);
      }, 700); // match duration-700
    }
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
  }, [isAnimating]);

  // Auto-scroll for desktop slider
  React.useEffect(() => {
    // Only auto-scroll on desktop (sm and up)
    const mediaQuery = window.matchMedia("(min-width: 640px)");
    if (!mediaQuery.matches) return;
    if (isAnimating ) return;
    const interval = setInterval(() => {
      handleNext();
    }, 3000);
    return () => clearInterval(interval);
  }, [isAnimating, activeIndex]);

  return (
    <div className="bg-[#F5F7FA] py-16 px-6 md:px-20">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
        {/* Left Content */}
        <div className="mt-2">
         {/* Desktop view: Split into two lines */}
<h2 className="hidden sm:block font-utility font-medium text-[54px] leading-[120%] tracking-[-0.01em] capitalize text-[#011621] mb-4">
  {(() => {
    const words = INFRA_PAGE.testStandards.title.split(" ");
    return (
      <>
        {words.slice(0, 2).join(" ")} <br />
        {words.slice(2, 5).join(" ")}
      </>
    );
  })()}
</h2>

{/* Mobile view: Single line below 500px */}
<h2 className="sm:hidden font-utility font-medium text-[30px] leading-[120%] tracking-[-0.01em] capitalize text-[#011621] mb-4">
  {INFRA_PAGE.testStandards.title}
</h2>
          <p className="font-inter font-normal text-[18px] leading-[150%] tracking-[-0.005em] text-[#033652] max-w-md">
            {INFRA_PAGE.testStandards.description}
          </p>
        </div>

        {/* Right Image + Info + Arrows */}
        <div>
          {/* Mobile: Swiper carousel */}
          <div className="sm:hidden w-full relative">
            {/* Arrows */}
            <button
              ref={prevSwiperRef}
              className="absolute left-2 top-[40%] -translate-y-1/2 z-30 w-[50px] h-[50px] flex items-center justify-center text-white md:hidden "
              aria-label="Previous test"
            >
              <img src={navigatePrev} alt="Previous" className="w-[50px] h-[50px]" />
            </button>
            <button
              ref={nextSwiperRef}
              className="absolute right-2 top-[40%] -translate-y-1/2 z-30 w-[50px] h-[50px] flex items-center justify-center text-white md:hidden "
              aria-label="Next test"
            >
              <img src={navigateNext} alt="Next" className="w-[50px] h-[50px]" />
            </button>
            <Swiper
              modules={[Navigation]}
              navigation={{ prevEl: prevSwiperRef.current, nextEl: nextSwiperRef.current }}
              onInit={(swiper: SwiperType) => {
                // @ts-ignore
                swiper.params.navigation.prevEl = prevSwiperRef.current;
                // @ts-ignore
                swiper.params.navigation.nextEl = nextSwiperRef.current;
                swiper.navigation.init();
                swiper.navigation.update();
                setActiveMobileIndex(swiper.realIndex);
              }}
              onSlideChange={(swiper: SwiperType) => setActiveMobileIndex(swiper.realIndex)}
              centeredSlides
              loop
              slidesPerView="auto"
              spaceBetween={11}
              className="w-full"
            >
              {tests.map((test, idx) => (
                <SwiperSlide
                  key={test.name}
                  style={{ width: 204 }}
                  className="flex flex-col transition-all duration-300 origin-top"
                >
                  <div className="relative w-full   overflow-hidden ">
                    <img src={test.image} alt={test.name} className="w-[248px] h-[180px] object-cover" />
                    <div className="absolute inset-0 bg-[#011621] opacity-40 pointer-events-none" />
                  </div>
                  <h4 className="mt-2 font-inter text-[14px] font-medium text-black text-center">{test.name}</h4>
                  <p className="font-inter text-[11px] font-normal text-[#4F7286] text-center">{test.standard}</p>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>

          {/* Desktop: Keep existing slider */}
          <div className="hidden sm:block"
           
          >
            <div className="relative w-full h-[425px] overflow-hidden">
              {/* Previous image (slide out) */}
              {isAnimating && (
                <img
                  src={prev.image}
                  alt={prev.name}
                  className={`w-full h-[425px] object-cover absolute top-0 left-0 transition-transform duration-700 ease-in-out z-10 ${
                    direction === 'right'
                      ? 'translate-x-0'
                      : 'translate-x-0'
                  } ${
                    direction === 'right'
                      ? '-translate-x-full'
                      : 'translate-x-full'
                  }`}
                  style={{
                    transform: direction === 'right'
                      ? 'translateX(0%)'
                      : 'translateX(0%)',
                    animation: direction === 'right'
                      ? 'slideOutLeft 0.7s forwards'
                      : 'slideOutRight 0.7s forwards',
                  }}
                />
              )}
              {/* Current image (slide in) */}
              <img
                src={current.image}
                alt={current.name}
                className={`w-full h-[425px] object-cover absolute top-0 left-0 transition-transform duration-700 ease-in-out z-20 ${
                  isAnimating
                    ? direction === 'right'
                      ? 'translate-x-full'
                      : '-translate-x-full'
                    : 'translate-x-0'
                }`}
                style={{
                  transform: isAnimating
                    ? direction === 'right'
                      ? 'translateX(100%)'
                      : 'translateX(-100%)'
                    : 'translateX(0%)',
                  animation: isAnimating
                    ? direction === 'right'
                      ? 'slideInRight 0.7s forwards'
                      : 'slideInLeft 0.7s forwards'
                    : undefined,
                }}
                onAnimationEnd={() => setIsAnimating(false)}
              />
              {/* Custom keyframes for sliding */}
              <style>{`
                @keyframes slideInRight {
                  from { transform: translateX(100%); }
                  to { transform: translateX(0%); }
                }
                @keyframes slideInLeft {
                  from { transform: translateX(-100%); }
                  to { transform: translateX(0%); }
                }
                @keyframes slideOutLeft {
                  from { transform: translateX(0%); }
                  to { transform: translateX(-100%); }
                }
                @keyframes slideOutRight {
                  from { transform: translateX(0%); }
                  to { transform: translateX(100%); }
                }
              `}</style>
            </div>

            <div className="flex items-center justify-between mt-4">
              <div>
                <h4 className="font-inter text-[18px] font-normal text-[#033652]">{current.name}</h4>
                <p className="font-inter text-[18px] font-normal text-[#4F7286]">{current.standard}</p>
              </div>

              
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

// Reusable button with hover and flip effect
const ButtonWithHoverImg: React.FC<{ onClick: () => void; alt: string; flip?: boolean }> = ({ onClick, alt, flip }) => {
  const [hover, setHover] = useState(false);
  return (
    <button
      onClick={onClick}
      className="w-[57px] h-[57px]  flex items-center justify-center transition p-0 bg-transparent"
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ overflow: "hidden" }}
    >
      <img
        src={hover ? buttonHover : buttonDefault}
        alt={alt}
        className={`w-[57px] h-[57px] object-contain${flip ? " scale-x-[-1]" : ""}`}
        style={flip ? { transform: "scaleX(-1)" } : undefined}
        draggable={false}
      />
    </button>
  );
};

export default TestStandardsSection;